import { render, staticRenderFns } from "./EditProductPackage.vue?vue&type=template&id=25c6035c&scoped=true"
import script from "./EditProductPackage.vue?vue&type=script&lang=js"
export * from "./EditProductPackage.vue?vue&type=script&lang=js"
import style0 from "./EditProductPackage.vue?vue&type=style&index=0&id=25c6035c&prod&scoped=true&lang=css"
import style1 from "../../../assets/styles/multiselect.css?vue&type=style&index=1&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25c6035c",
  null
  
)

export default component.exports